import {
    POST_WHITELISTED_BRAND_LOGIN,
    POST_WHITELISTED_BRAND_LOGIN_SUCCESS,
    POST_WHITELISTED_BRAND_LOGIN_ERROR,
    GET_WHITELISTED_BRANDS,
    GET_WHITELISTED_BRANDS_SUCCESS,
    GET_WHITELISTED_BRANDS_ERROR,
    CREATE_WHITELISTED_BRAND,
    CREATE_WHITELISTED_BRAND_SUCCESS,
    CREATE_WHITELISTED_BRAND_ERROR,
    UPDATE_WHITELISTED_BRAND,
    UPDATE_WHITELISTED_BRAND_SUCCESS,
    UPDATE_WHITELISTED_BRAND_ERROR,
    DELETE_WHITELISTED_BRAND,
    DELETE_WHITELISTED_BRAND_SUCCESS,
    DELETE_WHITELISTED_BRAND_ERROR,
    GET_WHITELISTED_BRANDS_ADMIN_USERS,
    GET_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS,
    GET_WHITELISTED_BRANDS_ADMIN_USERS_ERROR,
    GET_WHITELISTED_BRANDS_USER_MAPPINGS,
    GET_WHITELISTED_BRANDS_USER_MAPPINGS_SUCCESS,
    GET_WHITELISTED_BRANDS_USER_MAPPINGS_ERROR,
    UPDATE_WHITELISTED_BRANDS_USER_MAPPING,
    UPDATE_WHITELISTED_BRANDS_USER_MAPPING_SUCCESS,
    UPDATE_WHITELISTED_BRANDS_USER_MAPPING_ERROR,
    UPDATE_WHITELISTED_BRANDS_ADMIN_USERS,
    UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS,
    UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_ERROR,
  } from "./actionTypes"
  
  export const postWhitelistedBrandLogin = (whitelisted_brand) => {
    return {
      type: POST_WHITELISTED_BRAND_LOGIN,
      payload: whitelisted_brand
    }
  }
  
  export const postWhitelistedBrandLoginSuccess = whitelisted_brand => {
    return {
      type: POST_WHITELISTED_BRAND_LOGIN_SUCCESS,
      payload: whitelisted_brand,
    }
  }
  
  export const postWhitelistedBrandLoginError = error => {
    return {
      type: POST_WHITELISTED_BRAND_LOGIN_ERROR,
      payload: error,
    }
  }

  export const getWhitelistedBrands = () => {
    return {
      type: GET_WHITELISTED_BRANDS,
    }
  }
  
  export const getWhitelistedBrandsSuccess = (whitelisted_brands) => {
    return {
      type: GET_WHITELISTED_BRANDS_SUCCESS,
      payload: whitelisted_brands,
    }
  }
  
  export const getWhitelistedBrandsError = (error) => {
    return {
      type: GET_WHITELISTED_BRANDS_ERROR,
      payload: error,
    }
  }

  export const createWhitelistedBrand = (whitelisted_brand) => {
    return {
      type: CREATE_WHITELISTED_BRAND,
      payload: whitelisted_brand,
    }
  }

  export const createWhitelistedBrandSuccess = (whitelisted_brand) => {
    return {
      type: CREATE_WHITELISTED_BRAND_SUCCESS,
      payload: whitelisted_brand,
    }
  }

  export const createWhitelistedBrandError = (error) => {
    return {
      type: CREATE_WHITELISTED_BRAND_ERROR,
      payload: error,
    }
  }

  export const updateWhitelistedBrand = (whitelisted_brand) => {
    return {
      type: UPDATE_WHITELISTED_BRAND,
      payload: whitelisted_brand,
    }
  }

  export const updateWhitelistedBrandSuccess = (whitelisted_brand) => {
    return {
      type: UPDATE_WHITELISTED_BRAND_SUCCESS,
      payload: whitelisted_brand,
    }
  }

  export const updateWhitelistedBrandError = (error) => {
    return {
      type: UPDATE_WHITELISTED_BRAND_ERROR,
      payload: error,
    }
  }

  export const deleteWhitelistedBrand = (whitelisted_brand) => {
    return {
      type: DELETE_WHITELISTED_BRAND,
      payload: whitelisted_brand,
    }
  }

  export const deleteWhitelistedBrandSuccess = (whitelisted_brand) => {
    return {
      type: DELETE_WHITELISTED_BRAND_SUCCESS,
      payload: whitelisted_brand,
    }
  }

  export const deleteWhitelistedBrandError = (error) => {
    return {
      type: DELETE_WHITELISTED_BRAND_ERROR,
      payload: error,
    }
  }

  export const getWhitelistedBrandsAdminUsers = (whitelisted_brands) => {
    return {
      type: GET_WHITELISTED_BRANDS_ADMIN_USERS,
      payload: whitelisted_brands,
    }
  }

  export const getWhitelistedBrandsAdminUsersSuccess = (whitelisted_brands_admin_users) => {
    return {
      type: GET_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS,
      payload: whitelisted_brands_admin_users,
    }
  }

  export const getWhitelistedBrandsAdminUsersError = (error) => {
    return {
      type: GET_WHITELISTED_BRANDS_ADMIN_USERS_ERROR,
      payload: error,
    }
  }

  export const updateWhitelistedBrandsAdminUsers = (whitelisted_brands_admin_user) => {
    return {
      type: UPDATE_WHITELISTED_BRANDS_ADMIN_USERS,
      payload: whitelisted_brands_admin_user,
    }
  }

  export const updateWhitelistedBrandsAdminUsersSuccess = (whitelisted_brands_admin_users) => {
    return {
      type: UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS,
      payload: whitelisted_brands_admin_users,
    }
  }

  export const updateWhitelistedBrandsAdminUsersError = (error) => {
    return {
      type: UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_ERROR,
      payload: error,
    }
  }

  export const getWhitelistedBrandsUserMappings = () => {
    return {
      type: GET_WHITELISTED_BRANDS_USER_MAPPINGS,
    }
  }

  export const getWhitelistedBrandsUserMappingsSuccess = (whitelisted_brands_user_mappings) => {
    return {
      type: GET_WHITELISTED_BRANDS_USER_MAPPINGS_SUCCESS,
      payload: whitelisted_brands_user_mappings,
    }
  }

  export const getWhitelistedBrandsUserMappingsError = (error) => {
    return {
      type: GET_WHITELISTED_BRANDS_USER_MAPPINGS_ERROR,
      payload: error,
    }
  }

  export const updateWhitelistedBrandsUserMapping = (whitelisted_brands_user_mapping) => {
    return {
      type: UPDATE_WHITELISTED_BRANDS_USER_MAPPING,
      payload: whitelisted_brands_user_mapping,
    }
  }

  export const updateWhitelistedBrandsUserMappingSuccess = (whitelisted_brands_user_mapping) => {
    return {
      type: UPDATE_WHITELISTED_BRANDS_USER_MAPPING_SUCCESS,
      payload: whitelisted_brands_user_mapping,
    }
  }

  export const updateWhitelistedBrandsUserMappingError = (error) => {
    return {
      type: UPDATE_WHITELISTED_BRANDS_USER_MAPPING_ERROR,
      payload: error,
    }
  }
